import type { Template } from "@/types";

export const PO_07_H7_V0: Template[] = [
    {
        id: "po-07-h7v0-01",
        name: "PO 01 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 46, y: 260, width: 294, height: 194, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 462, width: 294, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 260, width: 293, height: 194, rotation: 0, imageRotation: 0 },
            { id: "4", x: 348, y: 462, width: 293, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 772, y: 195, width: 513, height: 347, rotation: 0, imageRotation: 0 },
            { id: "6", x: 772, y: 550, width: 253, height: 172, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1033, y: 550, width: 252, height: 172, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-02",
        name: "PO 02 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 70, y: 276, width: 546, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 764, y: 185, width: 269, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 764, y: 370, width: 269, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 764, y: 555, width: 269, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1041, y: 185, width: 269, height: 177, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1041, y: 370, width: 269, height: 177, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1041, y: 555, width: 269, height: 176, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-03",
        name: "PO 03 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 66, y: 196, width: 585, height: 388, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 592, width: 190, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 592, width: 190, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 462, y: 592, width: 189, height: 129, rotation: 0, imageRotation: 0 },
            { id: "5", x: 741, y: 166, width: 585, height: 377, rotation: 0, imageRotation: 0 },
            { id: "6", x: 741, y: 551, width: 289, height: 199, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1038, y: 551, width: 288, height: 199, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-04",
        name: "PO 04 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 44, y: 260, width: 599, height: 397, rotation: 0, imageRotation: 0 },
            { id: "2", x: 731, y: 260, width: 195, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 731, y: 395, width: 195, height: 127, rotation: 0, imageRotation: 0 },
            { id: "4", x: 731, y: 530, width: 195, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 934, y: 260, width: 195, height: 127, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1137, y: 260, width: 194, height: 127, rotation: 0, imageRotation: 0 },
            { id: "7", x: 934, y: 395, width: 397, height: 262, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-05",
        name: "PO 05 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 77, y: 177, width: 606, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 177, width: 606, height: 391, rotation: 0, imageRotation: 0 },
            { id: "3", x: 77, y: 576, width: 238, height: 163, rotation: 0, imageRotation: 0 },
            { id: "4", x: 323, y: 576, width: 238, height: 163, rotation: 0, imageRotation: 0 },
            { id: "5", x: 569, y: 576, width: 238, height: 163, rotation: 0, imageRotation: 0 },
            { id: "6", x: 815, y: 576, width: 237, height: 163, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1060, y: 576, width: 237, height: 163, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-06",
        name: "PO 06 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 59, y: 211, width: 308, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 375, y: 211, width: 308, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 211, width: 308, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1007, y: 211, width: 308, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 59, y: 427, width: 414, height: 279, rotation: 0, imageRotation: 0 },
            { id: "6", x: 481, y: 427, width: 413, height: 279, rotation: 0, imageRotation: 0 },
            { id: "7", x: 902, y: 427, width: 413, height: 279, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-07",
        name: "PO 07 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 220, width: 223, height: 154, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 382, width: 223, height: 153, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 543, width: 223, height: 153, rotation: 0, imageRotation: 0 },
            { id: "4", x: 231, y: 543, width: 222, height: 153, rotation: 0, imageRotation: 0 },
            { id: "5", x: 461, y: 543, width: 222, height: 153, rotation: 0, imageRotation: 0 },
            { id: "6", x: 231, y: 220, width: 452, height: 315, rotation: 0, imageRotation: 0 },
            { id: "7", x: 691, y: 220, width: 683, height: 476, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h7v0-08",
        name: "PO 08 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 220, width: 683, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 220, width: 223, height: 154, rotation: 0, imageRotation: 0 },
            { id: "3", x: 691, y: 382, width: 223, height: 153, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 543, width: 223, height: 153, rotation: 0, imageRotation: 0 },
            { id: "5", x: 922, y: 543, width: 222, height: 153, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1152, y: 543, width: 222, height: 153, rotation: 0, imageRotation: 0 },
            { id: "7", x: 922, y: 220, width: 452, height: 315, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-09",
        name: "PO 09 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 220, width: 683, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 691, y: 220, width: 223, height: 154, rotation: 0, imageRotation: 0 },
            { id: "3", x: 922, y: 220, width: 222, height: 154, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1152, y: 220, width: 222, height: 154, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1152, y: 382, width: 222, height: 153, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1152, y: 543, width: 222, height: 153, rotation: 0, imageRotation: 0 },
            { id: "7", x: 691, y: 382, width: 453, height: 314, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-10",
        name: "PO 10 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 53, y: 198, width: 257, height: 168, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 374, width: 257, height: 168, rotation: 0, imageRotation: 0 },
            { id: "3", x: 53, y: 550, width: 257, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 318, y: 198, width: 738, height: 520, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1064, y: 198, width: 256, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1064, y: 374, width: 256, height: 168, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1064, y: 550, width: 256, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },
   

];
